import React, { useState, useEffect } from 'react';
import '../styles/formStyles.css';
import { showAppAlert } from '../utils/alertService';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function SelectPromoModal({ visible, onClose, onPromoSelect }) {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPromoId, setSelectedPromoId] = useState('');
  const token = localStorage.getItem('token');
  const companyId = localStorage.getItem('company_id');

  useEffect(() => {
    if (visible && companyId) {
      const fetchPromos = async () => {
        setLoading(true);
        try {
          // Rota que retorna as promoções ativas da empresa
          const response = await fetch(`${API_URL}/promotions/active/company/${companyId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });
          if (response.ok) {
            const data = await response.json();
            setPromos(data);
          } else {
            console.error('Erro ao buscar promoções ativas');
            showAppAlert('error', 'Não foi possível carregar as promoções.');
            setPromos([]);
          }
        } catch (error) {
          console.error('Erro ao buscar promoções ativas:', error);
          showAppAlert('error', 'Erro de rede ao buscar promoções.');
        } finally {
          setLoading(false);
        }
      };
      fetchPromos();
    } else {
      // Limpa o estado quando o modal não está visível
      setPromos([]);
      setSelectedPromoId('');
    }
  }, [visible, companyId, token]);

  const handleConfirm = () => {
    if (!selectedPromoId) {
      showAppAlert('warning', 'Por favor, selecione uma promoção.');
      return;
    }
    const selectedPromo = promos.find(p => p.id.toString() === selectedPromoId);
    if (selectedPromo) {
      onPromoSelect(selectedPromo);
    }
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content small-modal">
        <h3 className="form-title">Selecione uma Promoção</h3>
        {loading && <p>Carregando promoções...</p>}
        {!loading && promos.length > 0 ? (
          <div className="label-style" style={{ marginBottom: '20px' }}>
            <label htmlFor="promo-select">Promoções Ativas:</label>
            <select
              id="promo-select"
              value={selectedPromoId}
              onChange={(e) => setSelectedPromoId(e.target.value)}
              className="input-style"
            >
              <option value="">-- Escolha uma promoção --</option>
              {promos.map((promo) => (
                <option key={promo.id} value={promo.id}>
                  {promo.nome} ({promo.pontos} pts)
                </option>
              ))}
            </select>
          </div>
        ) : !loading && <p>Nenhuma promoção ativa encontrada.</p>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button onClick={handleConfirm} className="button-style" disabled={!selectedPromoId || promos.length === 0}>
            Confirmar
          </button>
          <button onClick={onClose} className="button-style cancel">Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default SelectPromoModal;